/**
 * CompanySection — "(c) Company" on the one-page Confirm & book. The address
 * is typed ONCE here (the legacy flow asked for it on two different tabs).
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Select } from 'antd';
import countryList from 'react-select-country-list';
import {
  SectionCard,
  SectionHeading,
  SectionHint,
  FieldGrid,
  FullRow,
  fieldLabelStyle,
} from './confirmTheme';

const { Option } = Select;

const label = (text) => <span style={fieldLabelStyle}>{text}</span>;

const CompanySection = ({ form }) => {
  const { getFieldDecorator } = form;
  const options = countryList().getData();

  return (
    <SectionCard aria-label="Company details">
      <SectionHeading>Company</SectionHeading>
      <SectionHint>The company this shipment is booked under.</SectionHint>

      <FieldGrid>
        <FullRow>
          <Form.Item label={label('Company name')} colon={false}>
            {getFieldDecorator('company_name', {
              validateTrigger: 'onBlur',
              rules: [{ required: true, message: 'Please add your company name.' }],
            })(<Input size="large" autoComplete="organization" placeholder="Company name" />)}
          </Form.Item>
        </FullRow>
        <FullRow>
          <Form.Item label={label('Street address')} colon={false}>
            {getFieldDecorator('street', {
              validateTrigger: 'onBlur',
              rules: [{ required: true, message: 'Please add your street address.' }],
            })(<Input size="large" autoComplete="address-line1" placeholder="Street address" />)}
          </Form.Item>
        </FullRow>
        <FullRow>
          <Form.Item label={label('Address line 2 (optional)')} colon={false}>
            {getFieldDecorator('address2')(
              <Input size="large" autoComplete="address-line2" placeholder="Suite, unit, floor…" />
            )}
          </Form.Item>
        </FullRow>
        <Form.Item label={label('City')} colon={false}>
          {getFieldDecorator('city', {
            validateTrigger: 'onBlur',
            rules: [{ required: true, message: 'Please add your city.' }],
          })(<Input size="large" autoComplete="address-level2" placeholder="City" />)}
        </Form.Item>
        <Form.Item label={label('State / Province (optional)')} colon={false}>
          {getFieldDecorator('state_province')(
            <Input size="large" autoComplete="address-level1" placeholder="State / Province" />
          )}
        </Form.Item>
        <Form.Item label={label('ZIP / Postal code (optional)')} colon={false}>
          {getFieldDecorator('postal')(
            <Input size="large" autoComplete="postal-code" placeholder="ZIP / Postal code" />
          )}
        </Form.Item>
        <Form.Item label={label('Country')} colon={false}>
          {getFieldDecorator('country', {
            rules: [{ required: true, message: 'Please pick your country.' }],
          })(
            <Select
              size="large"
              showSearch
              placeholder="Select country"
              optionFilterProp="children"
            >
              {options.map((country) => (
                <Option key={country.value} value={country.label}>
                  {country.label}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </FieldGrid>
    </SectionCard>
  );
};

CompanySection.propTypes = {
  form: PropTypes.object.isRequired,
};

export default CompanySection;
